import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "bg-gray-blue-100 dark:bg-gray-bluer-800" }
const _hoisted_2 = { class: "bg-theme-600 pb-32" }
const _hoisted_3 = { class: "bg-theme-600 border-b border-theme-300 border-opacity-25 lg:border-none" }
const _hoisted_4 = { class: "max-w-7xl mx-auto px-2 sm:px-4 lg:px-8" }
const _hoisted_5 = { class: "relative h-16 flex items-center justify-between lg:border-b lg:border-theme-400 lg:border-opacity-25" }
const _hoisted_6 = { class: "px-2 flex items-center lg:px-0" }
const _hoisted_7 = { class: "flex space-x-4" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Dashboard ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Categories ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Terms ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Rate Types ")
const _hoisted_12 = { class: "py-10" }
const _hoisted_13 = { class: "flex items-center justify-between max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" }
const _hoisted_14 = { class: "text-3xl font-bold text-white" }
const _hoisted_15 = {
  key: 0,
  class: "flex items-center space-x-6"
}
const _hoisted_16 = { class: "-mt-32" }
const _hoisted_17 = { class: "max-w-7xl mx-auto pb-12 px-4 sm:px-6 lg:px-8" }
const _hoisted_18 = { class: "bg-white dark:bg-gray-bluer-600 rounded-lg shadow px-5 py-6 sm:px-6" }

import { computed } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

import { Theme }               from "@denfield/packages/ui/components/theme";
import { AppButton as Button } from "@greywind/ui";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const route = useRoute();

const title  = computed( () => store.getters[ "title/contents" ] );
const action = computed( () => store.getters[ "title/action" ] );
const back   = computed( () => store.getters[ "title/back" ] );


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_x_icon = _resolveComponent("x-icon")!

  return (_unref(route).path === '/401')
    ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _createVNode(_unref(Theme), { store: _unref(store) }, null, 8, ["store"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("nav", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_router_link, {
                        to: { name: 'Home' },
                        class: "nav-link text-white hover:bg-theme-500 hover:bg-opacity-75 rounded-md py-2 px-3 text-sm font-medium",
                        "aria-current": "page"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_router_link, {
                        to: { name: 'Categories' },
                        class: "nav-link text-white hover:bg-theme-500 hover:bg-opacity-75 rounded-md py-2 px-3 text-sm font-medium"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_router_link, {
                        to: { name: 'Terms' },
                        class: "nav-link text-white hover:bg-theme-500 hover:bg-opacity-75 rounded-md py-2 px-3 text-sm font-medium"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_router_link, {
                        to: { name: 'RateTypes' },
                        class: "nav-link text-white hover:bg-theme-500 hover:bg-opacity-75 rounded-md py-2 px-3 text-sm font-medium"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("header", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("h1", _hoisted_14, _toDisplayString(_unref(title)), 1),
                ((_unref(action) && _unref(action).route) || (_unref(back) && _unref(back).route))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      (_unref(back) && _unref(back).route)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: _unref(back).route,
                            class: "inline-flex text-white items-center space-x-2 text-opacity-75 hover:text-opacity-100 transition duration-150 ease-in-out"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_x_icon, {
                                icon: "fontawesome.arrow-left-long",
                                class: "w-5 h-5"
                              }),
                              _createElementVNode("span", null, _toDisplayString(_unref(back).label), 1)
                            ]),
                            _: 1
                          }, 8, ["to"]))
                        : _createCommentVNode("", true),
                      (_unref(action) && _unref(action).route)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 1,
                            to: _unref(action).route,
                            class: "inline-flex"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Button), {
                                theme: "light",
                                size: "medium"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(action).label), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["to"]))
                        : (_unref(action) && _unref(action).event)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 2,
                              href: "#",
                              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_unref(action).event && _unref(action).event(...args)), ["prevent"])),
                              class: "inline-flex"
                            }, [
                              _createVNode(_unref(Button), {
                                theme: "light",
                                size: "medium"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(action).label), 1)
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("main", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_router_view)
              ])
            ])
          ])
        ])
      ], 64))
}
}

})